module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_cp-fbf8284207784ac6ad0deeba49b30506.png";